import { WifiOff } from "lucide-react";
import { useEffect, useState } from "react";
import { api, isOnline, onConnectionChange } from "@/api/http";
import { useStore } from "@/model/store";

const PROBE_MS = 5000;

/** "Can't reach ModelCurve" under the header while the API is unreachable. It checks every few seconds, then catches up. */
export function NetworkBanner() {
	const [online, setOnline] = useState(isOnline());
	useEffect(() => onConnectionChange(setOnline), []);
	useEffect(() => {
		if (online) return;
		const t = setInterval(() => {
			api.get("/health", { etag: false }).then(
				() => void useStore.getState().refresh(),
				() => undefined,
			);
		}, PROBE_MS);
		return () => clearInterval(t);
	}, [online]);
	if (online) return null;
	return (
		<div role="status" className="flex items-center justify-center gap-2 border-b bg-destructive/10 px-4 py-1.5 text-sm text-destructive">
			<WifiOff className="size-4" aria-hidden /> Can’t reach ModelCurve. Retrying…
		</div>
	);
}
